module.exports = __webpack_public_path__ + "static/media/diversion-road.a37e5003.svg";